@if (notificationService.showNotification) {
    <div class="bh-toast">
        @if (notificationService.notificationType == 'toast') {
            <div class="toast-message bh-toast__message"
                 [class.success]="notificationService.messageType === NotificationMessageType.Success"
                 [class.error]="notificationService.messageType === NotificationMessageType.Error"
                 [class.warning]="notificationService.messageType === NotificationMessageType.Warning">
                 <div class="bh-toast__message-icon">
                     <span>{{ notificationService.message }}</span>
                    </div>
                <button type="button" class="btn btn-unstyled bh-toast__close" (click)="notificationService.resetNotification()"><i
                    class="far fa-close"></i></button>
            </div>
        }
        @if (notificationService.notificationType == 'modal') {
            <div>
                <div class="modal open notification">
                    <div class="modal-center-container">
                        <div class="modal-dialog modal-dialog-centered modal-center"
                             [ngClass]="(notificationService.otherBtn !== '') ? 'modal-third-button' : 'modal-sm'">
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
}
